import React, { useState } from 'react';
import { Box, Textarea, Button, Flex, Input, useColorModeValue, useToast, Spinner } from '@chakra-ui/react';
import { EditIcon, CloseIcon, ArrowForwardIcon } from '@chakra-ui/icons';

const Section = ({ id, content, ws, task, researchReport, user, agentName, agentRole, onUpdate, isSectionUpdating, isBeingUpdated, onEdit, onCancelUpdate, isEditDisabled, updatingSectionId }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedContent, setEditedContent] = useState(content);
  const [newTask, setNewTask] = useState('');
  const toast = useToast();

  const handleEdit = () => {
    setIsEditing(true);
    onEdit();
  };

  const handleCancel = () => {
    setIsEditing(false);
    setEditedContent(content);
    setNewTask('');
    onCancelUpdate();
  };

  const handleUpdate = async () => {
    await onUpdate(id, editedContent, newTask);
    setIsEditing(false);
    setNewTask('');
  };

  const bgColor = useColorModeValue('gray.50', 'gray.700');
  const highlightBgColor = useColorModeValue('green.100', 'green.700');
  const backgroundColor = isSectionUpdating && isBeingUpdated ? highlightBgColor : bgColor;

  return (
    <Box borderWidth="1px" p={4} my={4} borderRadius="md" bg={backgroundColor}>
      {isEditing ? (
        <>
          <Textarea value={editedContent} onChange={(e) => setEditedContent(e.target.value)} placeholder="Edit section content here" />
          <Input mt={2} value={newTask} onChange={(e) => setNewTask(e.target.value)} placeholder="Optional: Enter a new task" />
          <Flex justifyContent="space-between" mt={4}>
            <Button leftIcon={<ArrowForwardIcon />} colorScheme="blue" onClick={handleUpdate} isLoading={isSectionUpdating && isBeingUpdated}>Update</Button>
            <Button leftIcon={<CloseIcon />} colorScheme="red" onClick={handleCancel} isDisabled={isSectionUpdating}>Cancel</Button>
          </Flex>
        </>
      ) : (
        <div dangerouslySetInnerHTML={{ __html: content }} />
      )}
      {!isEditing && (
        <Button mt={4} leftIcon={<EditIcon />} onClick={handleEdit} isDisabled={isEditDisabled}>Edit</Button>
      )}
      {/* Show spinner next to the edit button if another section is being updated */}
      {isSectionUpdating && isBeingUpdated && <Spinner ml={4} />}

    </Box>
  );
};

export default Section;